import { cookieUtil } from '@/intl-jdi-common-ssr/utils/cookieUtils';
interface Cookies {
  [key: string]: number;
}
// 个性化推荐默认值
export const defaultPersonalised = {
  r: 0,
};

// cookie设置默认值
export const defaultUserCookie = {
  e: 1,
  f: 0,
  a: 0,
  t: 0,
};

// cookie，用户个性化推荐设置列表
export const getSettingList = (t: any) => {
  return {
    CookiesSettingList: [
      {
        key: 'e',
        title: t('cookie.essential'),
        content: t('cookie.essentialDescription'),
        isControl: false,
      },
      {
        key: 'f',
        title: t('cookie.functional'),
        content: t('cookie.functionalDescription'),
        isControl: true,
      },
      {
        key: 'a',
        title: t('cookie.analytics'),
        content: t('cookie.analyticsDescription'),
        isControl: true,
      },
      {
        key: 't',
        title: t('cookie.targetingAdvertising'),
        content: t('cookie.targetingAdvertisingDescription'),
        isControl: true,
      },
    ],
    PersonalisedSettingList: [
      {
        key: 'r',
        title: t('personalised.personalisedRecommendations'),
        content: t('personalised.recommendationsDescription'),
        isControl: true,
      },
    ],
  };
};

// 获取cooke_consent
export const getCookieConsent = () => {
  const cookieConsent = cookieUtil.getCookie('cookie_consent');
  return cookieConsent ? JSON.parse(cookieConsent) : defaultUserCookie;
};

// 设置cooke_consent
export const setCookieConsent = (cookies: Cookies) => {
  if (cookies) {
    cookieUtil.setCookie('cookie_consent', JSON.stringify(cookies), 30);
  }
};

// 获取personalised_consent
export const getPersonalisedConsent = () => {
  const personalisedConsent = cookieUtil.getCookie('personalised_consent');
  return personalisedConsent ? JSON.parse(personalisedConsent) : defaultPersonalised;
};

// 设置personalised_consent
export const setPersonalisedConsent = (cookies: Cookies) => {
  if (cookies) {
    cookieUtil.setCookie('personalised_consent', JSON.stringify(cookies), 365);
  }
};
